import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export default function SinAcceso() {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="Sin acceso"
      subTitle="No tienes permiso para ver esta sección. Contacta al administrador si crees que es un error."
      extra={
        <Button type="primary" onClick={() => navigate("/dashboard")}>
          Volver al inicio
        </Button>
      }
    />
  );
}
